var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBluetooth = function SvgBluetooth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.778 1.239a.834.834 0 0 0-1.418.596v8.462l-3.942-3.86a.834.834 0 1 0-1.167 1.192l4.55 4.457-4.55 4.458a.835.835 0 0 0 1.167 1.192l3.942-3.86v8.462a.835.835 0 0 0 1.418.596l5.131-5.032a.834.834 0 0 0 0-1.192l-4.722-4.624 4.722-4.625a.835.835 0 0 0 0-1.192zm.247 8.67 3.108-3.044-3.104-3.044v2.037l-.004.073zm0 5.018v-.663l3.108 3.043-3.104 3.044V15z",
    clipRule: "evenodd"
  })));
};
export default SvgBluetooth;